@if (size() === 'sm') {
  <!-- Small mode: Only sector name, 1M, and YTD, clickable card -->

   <div class="bg-white dark:bg-gray-800 rounded-lg shadow p-4">
        <h2 (click)="navigateToSectorList();" class="text-lg font-semibold text-gray-900 dark:text-white mb-4 ps-1">
           <i class="fas fa-building"> </i> Top Sectors
        </h2>
        <div class="grid grid-cols-1 gap-4">
            @for (sector of sectors(); track sector.sector) {
            <div
                class="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-4 border border-gray-200 dark:border-gray-700 cursor-pointer"
                (click)="navigateToSector(sector)">
                <!-- Sector Name -->
                <h3 class="text-lg font-bold text-gray-800 dark:text-white mb-2 text-center">{{ sector.sector }}</h3>

                <!-- Compact Metrics: 1M and YTD only -->
                <div class="grid grid-cols-2 gap-3">
                <div class="text-center">
                    <p class="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">1 Mo.</p>
                    <p class="text-sm font-bold" [class.text-green-600]="sector.m1 >= 0" [class.text-red-600]="sector.m1 < 0">
                    {{ sector.m1 | number:'1.2-2' }}%
                    </p>
                </div>
                <div class="text-center">
                    <p class="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">YTD</p>
                    <p class="text-sm font-bold" [class.text-yellow-600]="sector.ytd >= 0" [class.text-red-600]="sector.ytd < 0">
                    {{ sector.ytd | number:'1.2-2' }}%
                    </p>
                </div>
                </div>
            </div>
            }
        </div>
    </div>
} @else {
  <!-- Default mode: Full sector cards with all metrics and View Stocks button -->
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    @for (sector of sectors(); track sector.sector) {
      <div class="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-800 dark:to-gray-900 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border border-gray-200 dark:border-gray-700">
        <!-- Sector Name - Full Width at Top -->
        <h2 class="text-xl font-bold text-gray-800 dark:text-white mb-4 text-center">{{ sector.sector }}</h2>

        <!-- Performance Metrics Grid -->
        <div class="grid grid-cols-2 gap-4 mb-6">
          <div class="text-center">
            <p class="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-1">1 Mo.</p>
            <p class="text-lg font-bold" [class.text-green-600]="sector.m1 >= 0" [class.text-red-600]="sector.m1 < 0">
              {{ sector.m1 | number:'1.2-2' }}%
            </p>
          </div>
          <div class="text-center">
            <p class="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-1">3 Mo.</p>
            <p class="text-lg font-bold" [class.text-green-600]="sector.m3 >= 0" [class.text-red-600]="sector.m3 < 0">
              {{ sector.m3 | number:'1.2-2' }}%
            </p>
          </div>
          <div class="text-center">
            <p class="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-1">6 Mo.</p>
            <p class="text-lg font-bold" [class.text-green-600]="sector.m6 >= 0" [class.text-red-600]="sector.m6 < 0">
              {{ sector.m6 | number:'1.2-2' }}%
            </p>
          </div>
          <div class="text-center">
            <p class="text-sm font-semibold text-gray-600 dark:text-gray-300 mb-1">YTD</p>
            <p class="text-lg font-bold" [class.text-yellow-600]="sector.ytd >= 0" [class.text-red-600]="sector.ytd < 0">
              {{ sector.ytd | number:'1.2-2' }}%
            </p>
          </div>
        </div>

        <!-- View Details Button - Centered at Bottom -->
        <div class="text-center">
          <a
            [routerLink]="['/sectors', sector.sector.toLowerCase().replace(' ', '~')]"
            class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 inline-block">
            View Stocks
          </a>
        </div>
      </div>
    }
  </div>
}
